// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating Radio Player Styles */

.floating-radio-player {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    max-width: 400px;
    min-width: 320px;
}

.floating-radio-player.collapsed {
    width: 320px;
    height: auto;
}

.floating-radio-player.expanded {
    width: 400px;
    height: auto;
    max-height: 600px;
}

.player-content {
    position: relative;
    padding: 16px;
}

/* Minimized View Styles */
.player-mini {
    display: flex;
    align-items: center;
    gap: 12px;
}

.station-info-mini {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
    min-width: 0;
}

.station-image-mini {
    position: relative;
    flex-shrink: 0;
}

.mini-image {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.1);
}

.live-badge-mini {
    position: absolute;
    bottom: -2px;
    right: -2px;
    background: #ff4444;
    border-radius: 50%;
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.live-icon-mini {
    color: white;
    font-size: 8px;
}

.station-details-mini {
    flex: 1 1;
    min-width: 0;
}

.station-title-mini {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 4px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.program-info-mini {
    font-size: 12px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.player-controls-mini {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.control-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    min-width: 32px;
    min-height: 32px;
}

.control-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
}

.control-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.play-pause-btn {
    font-size: 16px;
}

.next-btn,
.volume-btn,
.expand-btn,
.close-btn {
    font-size: 14px;
}

/* Loading Spinner */
.loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Expanded View Styles */
.player-expanded {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.player-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
}

.station-info-expanded {
    display: flex;
    gap: 12px;
    flex: 1 1;
    min-width: 0;
}

.station-image-expanded {
    position: relative;
    flex-shrink: 0;
}

.expanded-image {
    width: 80px;
    height: 80px;
    border-radius: 12px;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.1);
}

.live-badge-expanded {
    position: absolute;
    bottom: 4px;
    right: 4px;
    background: #ff4444;
    border-radius: 12px;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 600;
    color: white;
}

.live-icon-expanded {
    font-size: 8px;
}

.station-details-expanded {
    flex: 1 1;
    min-width: 0;
}

.station-title-link {
    text-decoration: none;
}

.station-title-expanded {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 8px 0;
    line-height: 1.3;
}

.station-description-expanded {
    font-size: 13px;
    margin: 0 0 12px 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.current-program {
    margin-top: 8px;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
}

.program-title {
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 4px 0;
}

.program-time {
    font-size: 11px;
    margin: 0;
}

.player-actions-expanded {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}

.action-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 10px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    font-size: 16px;
    min-width: 40px;
    min-height: 40px;
}

.action-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
}

.action-btn.active {
    color: #ff4444;
}

.action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

/* Player Controls Expanded */
.player-controls-expanded {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
}

.main-controls {
    display: flex;
    align-items: center;
    justify-content: center;
}

.control-btn-large {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.control-btn-large:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.control-btn-large:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.loading-spinner-large {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top: 3px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

/* Volume Controls */
.volume-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    max-width: 200px;
}

.volume-btn-expanded {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.volume-btn-expanded:hover {
    background: rgba(255, 255, 255, 0.1);
}

.volume-slider {
    flex: 1 1;
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    outline: none;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
}

.volume-slider::-webkit-slider-thumb {
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: currentColor;
    cursor: pointer;
}

.volume-slider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: currentColor;
    cursor: pointer;
    border: none;
}

.volume-text {
    font-size: 12px;
    min-width: 35px;
    text-align: right;
}

/* Error Message */
.error-message-player {
    background: rgba(255, 68, 68, 0.1);
    border: 1px solid rgba(255, 68, 68, 0.3);
    border-radius: 8px;
    padding: 12px;
    text-align: center;
}

.error-message-player p {
    margin: 0 0 8px 0;
    font-size: 13px;
}

.retry-btn-player {
    background: transparent;
    border: 1px solid currentColor;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.retry-btn-player:hover {
    background: currentColor;
    color: white;
}

/* Audio Visualizer */
.audio-visualizer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    display: flex;
    align-items: end;
    gap: 1px;
    padding: 0 16px;
}

.visualizer-bar {
    flex: 1 1;
    background: linear-gradient(to top, #ff4444, #ff6666);
    border-radius: 1px;
    animation: visualize 1.5s ease-in-out infinite alternate;
}

.visualizer-bar.bar-1 { animation-delay: 0s; }
.visualizer-bar.bar-2 { animation-delay: 0.1s; }
.visualizer-bar.bar-3 { animation-delay: 0.2s; }
.visualizer-bar.bar-4 { animation-delay: 0.3s; }
.visualizer-bar.bar-5 { animation-delay: 0.4s; }

@keyframes visualize {
    0% { height: 1px; }
    100% { height: 3px; }
}

/* Autoplay Warning Animation */
@keyframes autoplayPulse {
    0% {
        opacity: 1;
        transform: scale(1);
        background: #ffc107;
    }
    50% {
        opacity: 0.7;
        transform: scale(1.05);
        background: #ff9800;
    }
    100% {
        opacity: 1;
        transform: scale(1);
        background: #ffc107;
    }
}

.autoplay-warning-mini {
    box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4);
    font-weight: bold;
    white-space: nowrap;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}

.autoplay-instruction {
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.autoplay-blocked-message {
    animation: slideUp 0.5s ease-in-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Access Modal Styles */
.access-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.access-modal {
    max-width: 400px;
    width: 90%;
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.access-modal-header {
    text-align: center;
    margin-bottom: 20px;
}

.lock-icon {
    font-size: 32px;
    color: #ffd700;
    margin-bottom: 12px;
}

.access-modal-header h3 {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
}

.access-modal-body {
    text-align: center;
    margin-bottom: 24px;
}

.access-modal-body p {
    margin: 0 0 12px 0;
    line-height: 1.5;
}

.access-modal-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
}

.access-btn {
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.access-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Station Preview Styles */
.station-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
}

.station-preview-image {
    width: 80px;
    height: 80px;
    border-radius: 12px;
    object-fit: cover;
    margin-bottom: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.station-preview h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
}

/* Access Button Variants */
.access-btn.register-btn,
.access-btn.plans-btn,
.access-btn.preview-btn {
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.access-btn.register-btn:hover,
.access-btn.plans-btn:hover,
.access-btn.preview-btn:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.subscribe-btn {
    border: none;
}

.cancel-btn {
    background: transparent;
    border: 1px solid currentColor;
}

.cancel-btn:hover {
    background: rgba(255, 255, 255, 0.1);
}

/* Responsive Design */
@media (max-width: 480px) {
    .floating-radio-player {
        bottom: 10px;
        right: 10px;
        left: 10px;
        max-width: none;
        min-width: auto;
    }
    
    .floating-radio-player.collapsed {
        width: auto;
    }
    
    .floating-radio-player.expanded {
        width: auto;
    }
    
    .player-header {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }
    
    .player-actions-expanded {
        flex-direction: row;
        justify-content: center;
    }
    
    .access-modal {
        margin: 20px;
        width: auto;
    }
    
    .access-modal-actions {
        flex-direction: column;
    }
}

/* Responsive modal actions for larger screens */
@media (min-width: 480px) {
    .access-modal-actions {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }
    
    .access-btn {
        flex: 0 0 auto;
        min-width: 120px;
    }
    
    .access-btn.cancel-btn {
        flex-basis: 100%;
        margin-top: 16px;
    }
}

/* Theme Integration */
.floating-radio-player.theme-bg-color {
    /* Theme background will be applied by parent component */
}

.theme-text-color {
    /* Theme text color will be applied by parent component */
}

.theme-button-bg-color {
    /* Theme button background will be applied by parent component */
}

.theme-button-text-color {
    /* Theme button text color will be applied by parent component */
}

/* Dark theme adjustments */
.floating-radio-player[data-theme="dark"] {
    background: rgba(20, 20, 20, 0.95);
    border-color: rgba(255, 255, 255, 0.1);
}

/* Light theme adjustments */
.floating-radio-player[data-theme="light"] {
    background: rgba(255, 255, 255, 0.95);
    border-color: rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Music/RadioStation/Components/FloatingRadioPlayer.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,2BAA2B;IAC3B,0CAA0C;IAC1C,iDAAiD;IACjD,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kCAAkC;IAClC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kCAAkC;IAClC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,qDAAqD;IACrD,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,qBAAqB,EAAE;;AAE/C;IACI,KAAK,WAAW,EAAE;IAClB,OAAO,WAAW,EAAE;AACxB;;AAEA,+BAA+B;AAC/B;IACI;QACI,UAAU;QACV,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;;;IAGI,6BAA6B;IAC7B,0CAA0C;AAC9C;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;QACZ,WAAW;QACX,UAAU;QACV,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA,sBAAsB;AACtB;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA,2BAA2B;AAC3B;IACI,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA,4BAA4B;AAC5B;IACI,qCAAqC;IACrC,gCAAgC;AACpC","sourcesContent":["/* Floating Radio Player Styles */\n\n.floating-radio-player {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 9999;\n    border-radius: 12px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow: hidden;\n    max-width: 400px;\n    min-width: 320px;\n}\n\n.floating-radio-player.collapsed {\n    width: 320px;\n    height: auto;\n}\n\n.floating-radio-player.expanded {\n    width: 400px;\n    height: auto;\n    max-height: 600px;\n}\n\n.player-content {\n    position: relative;\n    padding: 16px;\n}\n\n/* Minimized View Styles */\n.player-mini {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.station-info-mini {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n}\n\n.station-image-mini {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.mini-image {\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    object-fit: cover;\n    border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n.live-badge-mini {\n    position: absolute;\n    bottom: -2px;\n    right: -2px;\n    background: #ff4444;\n    border-radius: 50%;\n    padding: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.live-icon-mini {\n    color: white;\n    font-size: 8px;\n}\n\n.station-details-mini {\n    flex: 1;\n    min-width: 0;\n}\n\n.station-title-mini {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.program-info-mini {\n    font-size: 12px;\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.player-controls-mini {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.control-btn {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    min-width: 32px;\n    min-height: 32px;\n}\n\n.control-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n    transform: scale(1.1);\n}\n\n.control-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.play-pause-btn {\n    font-size: 16px;\n}\n\n.next-btn,\n.volume-btn,\n.expand-btn,\n.close-btn {\n    font-size: 14px;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top: 2px solid currentColor;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Expanded View Styles */\n.player-expanded {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.player-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.station-info-expanded {\n    display: flex;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n}\n\n.station-image-expanded {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.expanded-image {\n    width: 80px;\n    height: 80px;\n    border-radius: 12px;\n    object-fit: cover;\n    border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n.live-badge-expanded {\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n    background: #ff4444;\n    border-radius: 12px;\n    padding: 4px 8px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n    font-weight: 600;\n    color: white;\n}\n\n.live-icon-expanded {\n    font-size: 8px;\n}\n\n.station-details-expanded {\n    flex: 1;\n    min-width: 0;\n}\n\n.station-title-link {\n    text-decoration: none;\n}\n\n.station-title-expanded {\n    font-size: 18px;\n    font-weight: 700;\n    margin: 0 0 8px 0;\n    line-height: 1.3;\n}\n\n.station-description-expanded {\n    font-size: 13px;\n    margin: 0 0 12px 0;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.current-program {\n    margin-top: 8px;\n    padding: 8px 12px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 8px;\n}\n\n.program-title {\n    font-size: 13px;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n}\n\n.program-time {\n    font-size: 11px;\n    margin: 0;\n}\n\n.player-actions-expanded {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n}\n\n.action-btn {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 10px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    font-size: 16px;\n    min-width: 40px;\n    min-height: 40px;\n}\n\n.action-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n    transform: scale(1.1);\n}\n\n.action-btn.active {\n    color: #ff4444;\n}\n\n.action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Player Controls Expanded */\n.player-controls-expanded {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    align-items: center;\n}\n\n.main-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.control-btn-large {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.control-btn-large:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.control-btn-large:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.loading-spinner-large {\n    width: 24px;\n    height: 24px;\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    border-top: 3px solid currentColor;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n/* Volume Controls */\n.volume-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    max-width: 200px;\n}\n\n.volume-btn-expanded {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    padding: 8px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n}\n\n.volume-btn-expanded:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.volume-slider {\n    flex: 1;\n    height: 4px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 2px;\n    outline: none;\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n}\n\n.volume-slider::-webkit-slider-thumb {\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: currentColor;\n    cursor: pointer;\n}\n\n.volume-slider::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background: currentColor;\n    cursor: pointer;\n    border: none;\n}\n\n.volume-text {\n    font-size: 12px;\n    min-width: 35px;\n    text-align: right;\n}\n\n/* Error Message */\n.error-message-player {\n    background: rgba(255, 68, 68, 0.1);\n    border: 1px solid rgba(255, 68, 68, 0.3);\n    border-radius: 8px;\n    padding: 12px;\n    text-align: center;\n}\n\n.error-message-player p {\n    margin: 0 0 8px 0;\n    font-size: 13px;\n}\n\n.retry-btn-player {\n    background: transparent;\n    border: 1px solid currentColor;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.retry-btn-player:hover {\n    background: currentColor;\n    color: white;\n}\n\n/* Audio Visualizer */\n.audio-visualizer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    display: flex;\n    align-items: end;\n    gap: 1px;\n    padding: 0 16px;\n}\n\n.visualizer-bar {\n    flex: 1;\n    background: linear-gradient(to top, #ff4444, #ff6666);\n    border-radius: 1px;\n    animation: visualize 1.5s ease-in-out infinite alternate;\n}\n\n.visualizer-bar.bar-1 { animation-delay: 0s; }\n.visualizer-bar.bar-2 { animation-delay: 0.1s; }\n.visualizer-bar.bar-3 { animation-delay: 0.2s; }\n.visualizer-bar.bar-4 { animation-delay: 0.3s; }\n.visualizer-bar.bar-5 { animation-delay: 0.4s; }\n\n@keyframes visualize {\n    0% { height: 1px; }\n    100% { height: 3px; }\n}\n\n/* Autoplay Warning Animation */\n@keyframes autoplayPulse {\n    0% {\n        opacity: 1;\n        transform: scale(1);\n        background: #ffc107;\n    }\n    50% {\n        opacity: 0.7;\n        transform: scale(1.05);\n        background: #ff9800;\n    }\n    100% {\n        opacity: 1;\n        transform: scale(1);\n        background: #ffc107;\n    }\n}\n\n.autoplay-warning-mini {\n    box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4);\n    font-weight: bold;\n    white-space: nowrap;\n    pointer-events: none;\n    user-select: none;\n}\n\n.autoplay-instruction {\n    animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.autoplay-blocked-message {\n    animation: slideUp 0.5s ease-in-out;\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Access Modal Styles */\n.access-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n}\n\n.access-modal {\n    max-width: 400px;\n    width: 90%;\n    padding: 24px;\n    border-radius: 16px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.access-modal-header {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.lock-icon {\n    font-size: 32px;\n    color: #ffd700;\n    margin-bottom: 12px;\n}\n\n.access-modal-header h3 {\n    font-size: 20px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.access-modal-body {\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.access-modal-body p {\n    margin: 0 0 12px 0;\n    line-height: 1.5;\n}\n\n.access-modal-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 24px;\n}\n\n.access-btn {\n    padding: 12px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.access-btn:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Station Preview Styles */\n.station-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.station-preview-image {\n    width: 80px;\n    height: 80px;\n    border-radius: 12px;\n    object-fit: cover;\n    margin-bottom: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.station-preview h4 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n}\n\n/* Access Button Variants */\n.access-btn.register-btn,\n.access-btn.plans-btn,\n.access-btn.preview-btn {\n    background-color: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.access-btn.register-btn:hover,\n.access-btn.plans-btn:hover,\n.access-btn.preview-btn:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.subscribe-btn {\n    border: none;\n}\n\n.cancel-btn {\n    background: transparent;\n    border: 1px solid currentColor;\n}\n\n.cancel-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n    .floating-radio-player {\n        bottom: 10px;\n        right: 10px;\n        left: 10px;\n        max-width: none;\n        min-width: auto;\n    }\n    \n    .floating-radio-player.collapsed {\n        width: auto;\n    }\n    \n    .floating-radio-player.expanded {\n        width: auto;\n    }\n    \n    .player-header {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n    }\n    \n    .player-actions-expanded {\n        flex-direction: row;\n        justify-content: center;\n    }\n    \n    .access-modal {\n        margin: 20px;\n        width: auto;\n    }\n    \n    .access-modal-actions {\n        flex-direction: column;\n    }\n}\n\n/* Responsive modal actions for larger screens */\n@media (min-width: 480px) {\n    .access-modal-actions {\n        flex-direction: row;\n        justify-content: center;\n        flex-wrap: wrap;\n    }\n    \n    .access-btn {\n        flex: 0 0 auto;\n        min-width: 120px;\n    }\n    \n    .access-btn.cancel-btn {\n        flex-basis: 100%;\n        margin-top: 16px;\n    }\n}\n\n/* Theme Integration */\n.floating-radio-player.theme-bg-color {\n    /* Theme background will be applied by parent component */\n}\n\n.theme-text-color {\n    /* Theme text color will be applied by parent component */\n}\n\n.theme-button-bg-color {\n    /* Theme button background will be applied by parent component */\n}\n\n.theme-button-text-color {\n    /* Theme button text color will be applied by parent component */\n}\n\n/* Dark theme adjustments */\n.floating-radio-player[data-theme=\"dark\"] {\n    background: rgba(20, 20, 20, 0.95);\n    border-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Light theme adjustments */\n.floating-radio-player[data-theme=\"light\"] {\n    background: rgba(255, 255, 255, 0.95);\n    border-color: rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
